// extracted by mini-css-extract-plugin
export var legendIndicator = "_9n-1";
export var legendRight = "_9n-0";